<app-content-body *ngIf="!this.fetchedUserDetails" [isCentralized]='true' height='77vh'>
  <div class='sign-in-container text-center'>
    <div class="spinner-border spinner-signin" role="status" *ngIf='error === undefined'>
      <span class="sr-only">Loading...</span>
    </div>
    <h2 class="mb-5 mt-3" *ngIf='error === undefined'>Please wait while we log you in</h2>
    <h2 class="mb-5 mt-3" *ngIf='error !== undefined'>Sorry but we've encountered an error. Please try again.</h2>
    <p>{{error}}</p>
  </div>
</app-content-body>

<ng-template #PendingSubscriptions let-modal>
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">
      Pending Subscriptions
    </h6>
  </div>
  <div class="modal-body">
    <p>Following subscriptions are pending. If you have received an Invoice ID for any of these subscriptions, please select that subscription from the list and click 'Proceed' to continue.
    </p>
    <div *ngFor="let sub of pendingSubscriptions" class="subs-list">
      <input [id]="sub.id" type="radio" [(ngModel)]="this.selectedPendingSubscription" [value]="sub.id"/>
      <label [for]="sub.id">
        <strong> {{sub.name}}</strong>
      </label>
    </div>
  </div>
  <div class="modal-footer justify-content-right">
    <button [routerLink]="[environment.routes.quotation]"
      (click)="this.closeModal()"
      [queryParams]="{subscriptionId: selectedPendingSubscription}" class="btn btn-sm btn-primary"
      [disabled]="!!!this.selectedPendingSubscription">
      Proceed
    </button>
    <button [routerLink]="[environment.routes.environment]"
      class="btn btn-sm btn-outline-primary"
      (click)="this.closeModal()">
      Go to Dashboard
    </button>
  </div>
</ng-template>